import 'core-js/es6/';

import AuthService from 'common/auth/AuthService.js';
import Information from 'components/Information.react.js';
import MainSection from 'components/MainSection.jsx';
import OffSidebar from 'components/OffSidebar.jsx';
import Sidebar from 'components/Sidebar.jsx';
import keycloakService from 'keycloak/KeycloakService.js';
import { Suspense, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import Routes from '../routes/CreateRoutes.js';
import HeaderContainer from './HeaderContainer.jsx';
import createMenu from './Menu.js';

const App = ({ config, state }) => {
  const history = useHistory();
  const [isIFrame, setIsIFrame] = useState(false);
  const { isCloud, integradoUnico, unicoParcial, isStandalone } = config;

  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);
    setIsIFrame(queryParams.get('iframe') === 'true');
  }, [history.location.search]);

  const isLogged = AuthService.isLogged() || keycloakService.isLogged();
  const unicoUrl =
    integradoUnico || isCloud ? AuthService.getHost() + '/unico' : '';
  const unicoUrlParams = integradoUnico ? '?modulo=4' : '';

  const menu = createMenu({
    ...config,
    unicoUrl,
    unicoUrlParams,
    isLogged
  });

  return (
    <div className="wrapper">
      {!isIFrame && (
        <>
          <HeaderContainer
            unicoParcial={unicoParcial}
            integradoUnico={integradoUnico}
            isCloud={isCloud}
            standalone={isStandalone}
            isLogged={isLogged}
          >
            <OffSidebar
              info={state.info}
              hideTrocarEntidade={isLogged}
              showModulos={isLogged && isCloud}
              showLogin={!isLogged}
            />
          </HeaderContainer>
          <Sidebar menu={menu} />
        </>
      )}

      <Information />

      <MainSection isIFrame={isIFrame}>
        <Suspense fallback={<></>}>
          <Routes config={config} state={state} isIFrame={isIFrame} />
        </Suspense>
      </MainSection>
    </div>
  );
};

export default App;
